var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.875 1.1665C5.875 0.821326 6.15482 0.541504 6.5 0.541504L16.5 0.541505C16.8452 0.541505 17.125 0.821327 17.125 1.16651C17.125 1.51168 16.8452 1.79151 16.5 1.79151L6.5 1.7915C6.15482 1.7915 5.875 1.51168 5.875 1.1665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 1.1665C0.875 0.821326 1.15482 0.541504 1.5 0.541504L3.16667 0.541504C3.51185 0.541504 3.79167 0.821326 3.79167 1.1665C3.79167 1.51168 3.51185 1.7915 3.16667 1.7915L1.5 1.7915C1.15482 1.7915 0.875 1.51168 0.875 1.1665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.875 7C5.875 6.65482 6.15482 6.375 6.5 6.375L16.5 6.375C16.8452 6.375 17.125 6.65482 17.125 7C17.125 7.34518 16.8452 7.625 16.5 7.625L6.5 7.625C6.15482 7.625 5.875 7.34518 5.875 7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 7C0.875 6.65482 1.15482 6.375 1.5 6.375L3.16667 6.375C3.51185 6.375 3.79167 6.65482 3.79167 7C3.79167 7.34518 3.51185 7.625 3.16667 7.625L1.5 7.625C1.15482 7.625 0.875 7.34518 0.875 7Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.875 12.833C5.875 12.4878 6.15482 12.208 6.5 12.208L16.5 12.208C16.8452 12.208 17.125 12.4878 17.125 12.833C17.125 13.1782 16.8452 13.458 16.5 13.458L6.5 13.458C6.15482 13.458 5.875 13.1782 5.875 12.833Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 12.833C0.875 12.4878 1.15482 12.208 1.5 12.208L3.16667 12.208C3.51185 12.208 3.79167 12.4878 3.79167 12.833C3.79167 13.1782 3.51185 13.458 3.16667 13.458L1.5 13.458C1.15482 13.458 0.875 13.1782 0.875 12.833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogIcon);
export default __webpack_public_path__ + "static/media/catalogIcon.5536a53e340c711a0c7003ef24816a57.svg";
export { ForwardRef as ReactComponent };